/**
 * `localStorage` — só conveniência de apresentação, nunca estado de negócio
 * (CLAUDE.md, DESIGN-FOUNDATION §4.2). Sempre em try/catch; sem valor guardado,
 * a tela ainda funciona (o carimbo bate de novo, o onboarding reaparece).
 */

const CHAVE_ONBOARDING = 'varga.portal.onboarding.dispensado';
const CHAVE_VOUCHERS_VISTOS = 'varga.portal.vouchers.vistos';

export function onboardingDispensado(): boolean {
  try {
    return localStorage.getItem(CHAVE_ONBOARDING) === '1';
  } catch {
    return false;
  }
}

export function dispensarOnboarding(): void {
  try {
    localStorage.setItem(CHAVE_ONBOARDING, '1');
  } catch {
    /* storage indisponível — o card reaparece na próxima visita, inofensivo */
  }
}

export function vouchersVistos(): string[] {
  try {
    const cru = localStorage.getItem(CHAVE_VOUCHERS_VISTOS);
    if (!cru) return [];
    const v: unknown = JSON.parse(cru);
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function marcarVouchersVistos(ids: string[]): void {
  try {
    const atual = new Set(vouchersVistos());
    for (const id of ids) atual.add(id);
    localStorage.setItem(CHAVE_VOUCHERS_VISTOS, JSON.stringify([...atual]));
  } catch {
    /* o carimbo anima de novo no próximo carregamento — efeito colateral aceito (§4.2) */
  }
}
